import { useQuery, UseQueryResult } from "@tanstack/react-query";
import {CompanyDTO} from "@/shared/api/model";
// Import Orval-generated API client
import { useGetCompany } from '@/shared/api/client/companies';

export const getCompanyDisplayName = (company?: CompanyDTO | null): string => {
    return company?.brFname || company?.brName || company?.branchName || company?.branch || 'Institution';
};

export const useCompany = (): UseQueryResult<CompanyDTO, Error> => {
    const result = useGetCompany({
        query: {
            queryKey: ["companies"]
        }
    });
    // @ts-ignore
    return {
        ...result,
        data: result.data
    } as UseQueryResult<CompanyDTO, Error>;
};